import React from 'react'
import {Stack, Tooltip} from "@mui/material"
import {useProjectData} from "../../../hooks/useProjectData"
import {RoleCheck} from "../../../library/RoleCheck"
import NavSidebarLink from "./NavSidebarLink"
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined"
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined"
import PolylineOutlinedIcon from "@mui/icons-material/PolylineOutlined"

import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined"
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined"
import {Link} from "react-router-dom"
import SidebarShell from "../SidebarShell"
import {NAV_LABELS} from "../../../library/NavLabels"

function ProjectSidebar() {
    const {project, id} = useProjectData()

    if (!project)
        return <></>

    const isManager = RoleCheck.atLeastManager()
    const baseUrl = `/projects/${id}`

    return (
        <SidebarShell>
            {(collapsed) => (
                <>
                    <Stack spacing={2} alignItems={collapsed ? "center" : "stretch"}>
                        <Tooltip title={collapsed ? "All Projects" : ""} placement="right">
                            <Link
                                to="/"
                                style={{textDecoration: 'none'}}
                            >
                                <Stack
                                    direction="row"
                                    spacing={collapsed ? 0 : 1}
                                    alignItems="center"
                                    justifyContent={collapsed ? "center" : "flex-start"}
                                    sx={{
                                        px: collapsed ? 0 : 1.5,
                                        py: 0.75,
                                        color: '#888',
                                        fontSize: '0.85rem',
                                        mb: 1,
                                        '&:hover': {color: '#555'},
                                    }}
                                >
                                    <ArrowBackOutlinedIcon sx={{fontSize: 16}}/>
                                    {!collapsed && <span>All Projects</span>}
                                </Stack>
                            </Link>
                        </Tooltip>

                        <NavSidebarLink to="" baseUrl={baseUrl} icon={TableChartOutlinedIcon} collapsed={collapsed}>
                            {NAV_LABELS.TABLE}
                        </NavSidebarLink>

                        {isManager &&
                            <NavSidebarLink to="custom-models" baseUrl={baseUrl} icon={RocketLaunchOutlinedIcon} collapsed={collapsed}>
                                {NAV_LABELS.MODELS}
                            </NavSidebarLink>
                        }


                    </Stack>

                    <Stack spacing={2} alignItems={collapsed ? "center" : "stretch"}>
                        {isManager &&
                            <NavSidebarLink to="completions" baseUrl={baseUrl} icon={PolylineOutlinedIcon} collapsed={collapsed}>
                                {NAV_LABELS.HISTORY}
                            </NavSidebarLink>
                        }

                        {isManager &&
                            <NavSidebarLink to="settings" baseUrl={baseUrl} icon={SettingsOutlinedIcon} collapsed={collapsed}>
                                {NAV_LABELS.SETTINGS}
                            </NavSidebarLink>
                        }
                    </Stack>
                </>
            )}
        </SidebarShell>
    )
}

export default ProjectSidebar
